// Popularity
import { ChevronUp } from "lucide-react";
import Popularity from "./Popularity";
import Recent from "./Recent";
import { useEffect, useState } from "react";
import LinkIcon from "./LinkIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

function Card() {

  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get('q');
    if (searchParam) {
      dispatch({ type: "SET_SEARCH_TEXT", payload: searchParam });
    } 
  }, [location.search, dispatch]);

  return (
    <>
      <LinkIcon/>
      <div className="min-h-screen px-4">
        <Popularity className="my-8" />
        <Recent ctgId={0}/>
      </div>
    </>
    
  );
}

export default Card;
